<div class="custom-grid">
  <kendo-grid #grid [data]="dataView" [resizable]="true" [pageable]="false" [pageSize]="state.take" [skip]="state.skip" [navigatable]="true"
    [height]="500" (dataStateChange)="dataStateChange($event)">
    <kendo-grid-column [field]="item.field" [title]="item.title" [width]="120" 
      *ngFor="let item of getColumns(columns); let  i = index">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="item.field.includes('date')">
        <div *ngIf="item.isUrl&&item.field==='inspection_date'" (click)="editItem(dataItem, i)" class="cursor-pointer text-primary">{{dataItem.date |
          date
          : "dd-MM-YYYY"}}</div>
        <div *ngIf="item.field==='inspection_date&&!item.isUrl'"><span>{{dataItem.date | date : "dd-MM-YYYY"}}</span>
        </div>
        <div *ngIf="item.field==='action_due_date'"><span>{{dataItem.action_due_date | date : "dd-MM-YYYY"}}</span>
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem"  let-originalData="originalSite" *ngIf="item.field==='monthYear'">
        <div *ngIf="item.isUrl&&dataItem.site===originalSite" (click)="editItem(dataItem, i)"
          class="cursor-pointer text-primary text-decoration-underline">
          {{dataItem.monthYear}}
        </div>
        <div *ngIf="!item.isUrl||dataItem.site!==originalSite">{{dataItem.monthYear}}</div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="item.field==='id'">
        <button kendoGridRemoveCommand [id]="'delete'+i"
          (click)="deletItem(dataItem, i)">{{"common.remove_label" | xlat}}</button>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="item.field==='attachments'">
        <div class="grid-thumbviewer" *ngFor="let item of dataItem.attachments; let  i = index">
             <oc-thumbnail [ngModel]="item" [readOnly]="false" ngDefaultControl></oc-thumbnail> 
        </div>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" *ngIf="item.field!=='id'&&item.field!=='date'&&item.field!=='monthYear'&&item.field!=='attachments'">
        <div [ngClass]="item.style ? item.style(dataItem) : ''">{{getItem(dataItem, i)}}</div>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
      <div>
      </div>
      <p>{{"lastVisualInspection.NoSearchResults" | xlat}}</p>
    </ng-template>
      <ng-template kendoPagerTemplate let-totalPages="total" #noresults
    let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
            <kendo-pager-numeric-buttons [buttonCount]="buttonCount"></kendo-pager-numeric-buttons>
            <div  *ngIf="!totalPages||totalPages===0" class="k-pager-info k-label">{{"framework.gridPagerEmpty" | xlat}}</div>
            <div  *ngIf="totalPages&&totalPages>0" class="k-pager-info k-label">{{"UI.Resource.Common.Total" | xlat}}: {{total}}</div>
            <kendo-pager-next-buttons></kendo-pager-next-buttons>
            <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
</div>